import { createClient } from '@supabase/supabase-js'

// Market Data Supabase Project (dlvagtlgljtocwlstzvj)
// Contains: trades, candles, chart data
const marketDataUrl = import.meta.env.VITE_MARKET_DATA_SUPABASE_URL
const marketDataAnonKey = import.meta.env.VITE_MARKET_DATA_SUPABASE_ANON_KEY

// Create client only if env vars are available
// Falls back gracefully if market-data project not configured
export const supabaseMarketData = marketDataUrl && marketDataAnonKey
  ? createClient(marketDataUrl, marketDataAnonKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false,
      },
    })
  : null

export const isMarketDataConfigured = (): boolean => {
  return supabaseMarketData !== null
}
